import { processAt } from '@/common/parser/at-processor';
const xss = require('xss');
interface XssOptions {
    whiteList: any;
    stripIgnoreTag: boolean;
    stripIgnoreTagBody: string[];
}
export function transformHashTag(content: string) {
    if (content) {
        content = content.replace(/(#[^\n#\s@].*?)([^@\s#]*)/g, (sub: string) => {
            return `<a href="/hashtag/${sub.slice(1)}?source=3" target="_blank">${sub}</a>`;
        });
        return content;
    }
    return '';
}

// 转义用户的at tag
export function transformAtContent(content: string, canJump = true): string {
    if (content) {
        const result = processAt([{
            type: 'plainText',
            value: content,
        }]);
        const finalTitle = result.reduce((pre: string, cur: any ) => {
            if (cur.type === 'plainText') {
                return pre + cur.value;
            }
            if (cur.type === 'at' && cur.value) {
                if (canJump) {
                    return pre + `<a href="/profile/${cur.value.userId}" target="_blank">${cur.value.content}</a>`;
                }
                return pre + cur.value.content;
            }
        }, '');
        return finalTitle;
    }
    return '';
}

export function filterXss<T extends XssOptions>(content: string, options?: T): string {
    const { whiteList = [], stripIgnoreTag = true, stripIgnoreTagBody = ['script'] } = options as T || {};
    return xss(content, {
        whiteList, // 白名单标签
        stripIgnoreTag, // 是否过滤所有非白名单标签的HTML
        stripIgnoreTagBody, // 是否过滤标签中间的内容
    });
}

export function transformText(content: string, noParseHashTag?: boolean): string {
    if (!noParseHashTag) {
        content = transformHashTag(content);
    }
    content = transformAtContent(content);
    return filterXss(content, {
        whiteList: {
            a: ['href', 'title', 'target'], // 给hashtag，at这些转义之后a标签开白名单
        },
        stripIgnoreTag: true, // 过滤所有非白名单标签的HTML，防止xss
        stripIgnoreTagBody: ['script'], // script标签较特殊，需要过滤标签中间的内容
    });
}